export default "__VITE_ASSET__9f8f30b5__"